import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';
import showElement from '../util/show-element';
import slideToggle from '../util/slide-toggle';
import throttle from '../util/throttle';

const selectors = {
  elements: {
    accordion: '[data-accordion]',
    accordionToggle: '[data-accordion-toggle]',
    accordionBody: '[data-accordion-body]',
    accordionExpandValue: 'data-accordion-expand',
    accordionBlockValue: 'data-block-id',
  },
  classes: {
    open: 'is-open',
  },
};

const sections = {};

class GlobalAccordions {
  constructor(el) {
    this.container = el.container;
    this.accordion = this.container.querySelector(selectors.elements.accordion);
    this.accordionToggles = this.container.querySelectorAll(selectors.elements.accordionToggle);
    this.accordionTogglesLength = this.accordionToggles.length;
    this.accordionBody = this.container.querySelector(selectors.elements.accordionBody);

    if (this.accordionTogglesLength && this.accordionBody) {
      this.accordionEvents();
    }
  }

  accordionEvents() {
    this.accordionToggles.forEach((element) => {
      element.addEventListener(
        'click',
        throttle((event) => {
          event.preventDefault();
          const targetAccordionBody = element.parentElement.querySelector(selectors.elements.accordionBody);
          if (targetAccordionBody) {
            slideToggle(targetAccordionBody);
            element.classList.toggle(selectors.classes.open);
          }
        }, 800)
      );
    });

    if (this.accordion.getAttribute(selectors.elements.accordionExpandValue) === 'true') {
      this.accordionToggles[0].classList.add(selectors.classes.open);

      showElement(this.accordionToggles[0].parentElement.querySelector(selectors.elements.accordionBody));
    }
  }

  blockToggle(evt, blockSelect = true) {
    const targetAccordionToggle = this.container.querySelector(`${selectors.elements.accordionToggle}[${selectors.elements.accordionBlockValue}="${evt.detail.blockId}"]`);
    if (!targetAccordionToggle) return;
    const targetAccordionBody = targetAccordionToggle.parentElement.querySelector(selectors.elements.accordionBody);
    if (!targetAccordionBody) return;
    targetAccordionToggle.classList.toggle(selectors.classes.open, blockSelect);
    if (blockSelect) {
      slideDown(targetAccordionBody);
    } else {
      slideUp(targetAccordionBody);
    }
  }

  onDeselect() {
    if (this.accordionBody && this.accordionTogglesLength && this.accordionTogglesLength < 2) {
      slideUp(this.accordionBody);
      this.accordionToggles[0].classList.remove(selectors.classes.open);
    }
  }

  onSelect() {
    if (this.accordionBody && this.accordionTogglesLength && this.accordionTogglesLength < 2) {
      slideDown(this.accordionBody);
      this.accordionToggles[0].classList.add(selectors.classes.open);
    }
  }

  onBlockSelect(evt) {
    this.blockToggle(evt, true);
  }

  onBlockDeselect(evt) {
    this.blockToggle(evt, false);
  }
}

const accordions = {
  onLoad() {
    sections[this.id] = new GlobalAccordions(this);
  },
  onSelect() {
    sections[this.id].onSelect();
  },
  onDeselect() {
    sections[this.id].onDeselect();
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections[this.id].onBlockDeselect(e);
  },
};

export default accordions;
